import { render, staticRenderFns } from "./FavoriteWidget.vue?vue&type=template&id=4478a048&scoped=true&"
import script from "./FavoriteWidget.vue?vue&type=script&lang=js&"
export * from "./FavoriteWidget.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteWidget.vue?vue&type=style&index=0&id=4478a048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478a048",
  null
  
)

export default component.exports